import React, { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GeocodingFeature } from '../../../../common/types/mapbox-search-api-v1.types.ts';

import { selectStyle } from '../../../store';
import {
  activeItemChanged,
  selectActiveItem,
} from '../../../../pages/item-details/store';
import { compilePath } from '../../../../common/utils/helpers/routes';
import { ITEM_TYPES } from '../../../../common/utils/constants/constants';
import { getItemType } from '../../../../common/utils/helpers/item';
import InteractiveMapLayer from '../interactive-map-layer/InteractiveMapLayer';

import { getLayerStyleData, sourceId, sourceLayer } from './RoadLayerStyle';

const getItemFromFeature = (feature): GeocodingFeature => {
  const { id, geometry, properties } = feature;

  return {
    type: 'Feature',
    geometry,
    properties: {
      sourceLayerFeatureId: id,
      place_type: [ITEM_TYPES.road],
      ...properties,
    },
  };
};

const RoadLayer = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const currentMapStyle = useSelector(selectStyle);
  const { style: layerStyle, layerId } = useMemo(
    () => getLayerStyleData(currentMapStyle.id),
    [currentMapStyle],
  );

  const item = useSelector(selectActiveItem);
  const selectedFeature = useMemo(
    () => (getItemType(item) === ITEM_TYPES.road ? item : null),
    [item],
  );
  const selectedFeatureId = selectedFeature?.properties?.sourceLayerFeatureId;

  const onFeatureClick = useCallback(
    (mapFeature) => {
      dispatch(
        activeItemChanged({
          item: getItemFromFeature(mapFeature),
        }),
      );

      history.push({
        pathname: compilePath('edit'),
        search: history.location.search,
      });
    },
    [dispatch, history],
  );

  return (
    <InteractiveMapLayer
      sourceId={sourceId}
      sourceLayer={sourceLayer}
      layerId={layerId}
      layerStyle={layerStyle}
      selectedFeatureId={selectedFeatureId}
      onFeatureClick={onFeatureClick}
    />
  );
};

export default RoadLayer;
